import { render, staticRenderFns } from "./StorageStep.vue?vue&type=template&id=0a4c476a"
import script from "./StorageStep.vue?vue&type=script&lang=js"
export * from "./StorageStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports